/**
* Custom hook to toggle theme between light and dark mode
* In order for this to work
* public/index.html -> <body className="dark"/>
* tailwind.config.js -> darkMode: "class"
*/
import { useEffect, useState } from 'react';

export function useThemeSwitch (initialState = true) {
    const [theme, setTheme] = useState<Boolean>(initialState);
    
    function toggleTheme() {
        setTheme(!theme);
    }  
    
    useEffect(()=>{        
        if (!theme) document.body.classList.add("dark");
        else document.body.classList.remove("dark");
      },[theme]);

    return [theme, toggleTheme] as const;
}